import { checkUserId, getResponseData } from "../helpers/_functions";
import http from "../http-common";
import BaseService from "./base.service";

class EmploiSalaireService extends BaseService {
  constructor() {
    super("emploi-salaire");
  }
  getByEmployer(userId, params = {}) {
    userId = checkUserId(userId);
    return http
      .get(`${this.path}/getByEmployer/${userId}`, { params })
      .then((response) => getResponseData(response, true));
  }
  checkNumEmploye(numEmploye, idEmployer) {
    const adminUserId = localStorage.getItem("idAdminEnterprise");
    return http
      .post(`${this.path}/check-num-employe`, {
        numEmploye,
        adminUserId,
        idEmployer
      })
      .then((response) => getResponseData(response));
  }
  bulkUpdateHolidays(payload) {
    return http
      .put(`${this.path}/bulk-update-holidays`, payload)
      .then((response) => getResponseData(response));
  }
  bulkUpdateJob(payload) {
    return http
      .put(`${this.path}/bulk-update-job`, payload)
      .then((response) => getResponseData(response));
  }
  bulkUpdateBankingInsurance(payload) {
    return http
      .put(`${this.path}/bulk-update-bankingInsurance`, payload)
      .then((response) => getResponseData(response));
  }
  bulkUpdateSecurity(payload) {
    return http
      .put(`${this.path}/bulk-update-security`, payload)
      .then((response) => getResponseData(response));
  }
}

export default new EmploiSalaireService();
